import { validate as veeValidate } from 'vee-validate';
import { isObjectLike } from 'lodash';

export default {
  validate: async (value, {
    condition = null,
    controlValue = null,
    fieldValue,
    fieldRules,
  }) => {
    if (typeof condition === 'boolean') {
      return {
        valid: condition ? value !== controlValue : value === controlValue,
        required: false,
      };
    }
    if (
      isObjectLike(condition) &&
      Object.prototype.hasOwnProperty.call(condition, 'field') &&
      Object.prototype.hasOwnProperty.call(condition, 'rules')
    ) {
      const { valid } = await veeValidate(condition.field, condition.rules);
      return {
        valid: valid ? value !== controlValue : value === controlValue,
        required: false,
      };
    }
    return {
      valid: true,
      required: false,
    };
  },
  params: ['condition', 'controlValue', 'fieldValue', 'fieldRules'],
  computesRequired: true,
};
